import { useContext } from 'react';
import { HomeContext } from '../contexts';
import { IHome } from '../types';

export default function useHome(): IHome | undefined {
  const categories = useContext(HomeContext);
  return categories;
}
